import type { Routes } from '@angular/router';

import { SuggestionsStore } from '#modules/informations/stores/suggestions.store';

export const INFORMATION_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/informations/views/general-information.component').then((m) => m.GeneralInformationComponent),
        providers: [SuggestionsStore],
    },
];
